import { configureStore } from "@reduxjs/toolkit";
import humanResource from "./redux";

const store = configureStore({
    reducer:{
        humanResource:humanResource.reducer,
    }
})
export default store;